"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = exports.Button = void 0;
var button_1 = require("./Button/button");
Object.defineProperty(exports, "Button", { enumerable: true, get: function () { return button_1.Button; } });
var iconButton_1 = require("./IconButton/iconButton");
Object.defineProperty(exports, "IconButton", { enumerable: true, get: function () { return iconButton_1.IconButton; } });
//# sourceMappingURL=index.js.map